function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1A87C7;}\n\t.st1{fill:#66CEEF;}\n\t.st2{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M202.9,480.5c0.2-2.8,0.5-5.6,1.1-8.4c-0.6,2.9-0.9,5.8-1.1,8.7C202.8,480.8,202.9,480.7,202.9,480.5 C202.9,480.6,202.9,480.6,202.9,480.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.2,874.4l-0.2-0.1c0.2,0.1,1.1,0.7,1.2,0.8c-0.3-0.1-0.4-0.4-0.7-0.5C286.4,874.4,286.3,874.4,286.2,874.4 z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.3,453.8c0,0,0-0.1,0-0.1c-1.9,4-3.5,8.1-4.8,12.3c0,0,0-0.1,0-0.1C206.8,461.7,208.4,457.7,210.3,453.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M726,146.2c0.8,0,1.5,0,2.3,0C727.5,146.1,726.8,146.2,726,146.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M808.5,190.3c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0,0.1,0.1,0.1,0.2C808.4,190.3,808.5,190.3,808.5,190.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M218.2,440.7c-3,4-5.6,8.3-7.8,12.8c0,0,0,0,0,0C212.6,449,215.2,444.7,218.2,440.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M821.1,543c0-0.1,0-0.1,0-0.2C821.1,542.9,821.1,543,821.1,543C821.1,543,821.1,543,821.1,543z"
}), React.createElement("path", {
  className: "st0",
  d: "M204.9,468.7c-0.1,0.4-0.2,0.8-0.3,1.2C204.6,469.5,204.8,469.1,204.9,468.7 C204.9,468.7,204.9,468.7,204.9,468.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M709.2,151c2.3-1.3,4.6-2.3,6.8-3C713.5,148.8,711.2,149.8,709.2,151z"
}), React.createElement("path", {
  className: "st0",
  d: "M717.6,147.4c1.6-0.5,3.2-0.8,4.7-1.1C720.6,146.6,719.1,147,717.6,147.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M821.1,253.5c0,0.1,0.1,0.1,0.1,0.2c0-0.2,0-0.4-0.1-0.7V253.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M735.1,147.9c-0.2-0.1-0.3-0.1-0.5-0.1c0.2,0.1,0.5,0.1,0.7,0.2C735.2,148,735.2,147.9,735.1,147.9z"
}), React.createElement("polygon", {
  className: "st1",
  points: "213.8,490.3 213.8,517.7 275.3,553.2 275.3,525.8  "
}), React.createElement("path", {
  className: "st0",
  d: "M202.8,480.9v40c0,0,0,0,0,0L202.8,480.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M205.5,516.1c0.9-0.5,1.8-0.7,2.8-0.7c0-9.4,0-18.8,0-28.2l-2.7-1.6c-1.8-1-2.8-3-2.7-5c0,0.1-0.1,0.2-0.1,0.2 l0,39.9C202.9,518.8,203.9,517.1,205.5,516.1z"
}), React.createElement("polygon", {
  className: "st0",
  points: "275.3,553.2 213.8,517.7 213.8,490.3 213.7,490.3 213.7,517.7 275.3,553.2  "
}), React.createElement("path", {
  className: "st0",
  d: "M213.7,517.7l0-27.4l-5.4-3.1c0,9.4,0,18.8,0,28.2c0.9,0,1.8,0.2,2.7,0.7L213.7,517.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M285.5,490.3c3.1-5.4,6.7-10.2,10.7-14.3c4.1-4.3,8.6-7.9,13.2-10.6l472.1-272.6v-0.1c0.6-0.3,1.1-0.5,1.7-0.8 c1.2-0.6,2.3-1.2,3.5-1.7l-46.5-26.9l-9.7-5.6c-1.6-0.6-3.2-1-4.9-1c0,0,0,0,0,0c-1.4,0-2.8,0.3-4.4,0.8c-0.6,0.2-1.2,0.4-1.7,0.6 c-1.6,0.6-3.2,1.3-5,2.3L242.4,433c-3.8,2.3-7.4,5.3-10.7,8.7c-1.1,1.1-1.9,2.5-2.9,3.7c-2,2.4-4,4.8-5.6,7.4 c-0.2,0.4-0.4,0.8-0.6,1.2L285.5,490.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M714.5,160.5c1.8-1,3.5-1.7,5-2.3C717.7,158.9,716,159.7,714.5,160.5z"
}), React.createElement("path", {
  className: "st2",
  d: "M223.3,452.8c1.6-2.7,3.6-5.1,5.6-7.4C226.9,447.7,224.9,450.1,223.3,452.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M721.2,157.6c1.5-0.4,3-0.8,4.4-0.8C724.2,156.9,722.7,157.2,721.2,157.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M231.8,441.7c3.3-3.4,6.8-6.4,10.7-8.7C238.6,435.2,235.1,438.2,231.8,441.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M740.2,163.4l-10-5.8c-1.4-0.7-3-0.8-4.6-0.8c1.7,0,3.3,0.3,4.9,1L740.2,163.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M808.1,190C808.1,190,808.1,190.1,808.1,190C808.2,190.1,808.2,190,808.1,190l-72.6-41.9c0,0-0.1,0-0.1,0 c0.1,0.1,0.3,0.1,0.4,0.2L808.1,190z"
}), React.createElement("path", {
  className: "st0",
  d: "M204,472.2c0.2-0.8,0.4-1.5,0.6-2.3C204.4,470.6,204.1,471.4,204,472.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M716,147.9c0.5-0.2,1.1-0.3,1.6-0.5C717,147.6,716.5,147.7,716,147.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M722.2,146.4c1.2-0.2,2.5-0.2,3.7-0.2C724.8,146.2,723.5,146.2,722.2,146.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M728.3,146.2c2,0.2,4.1,0.7,6.3,1.6C732.6,146.9,730.5,146.4,728.3,146.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M236.9,423.6L709.2,151L236.9,423.6c-7,4.1-13.4,10.1-18.6,17.1C223.5,433.8,229.8,427.9,236.9,423.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M202.9,480.5C202.9,480.6,202.9,480.6,202.9,480.5L202.9,480.5C202.9,480.6,202.9,480.6,202.9,480.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M213.7,450.8c1.3-0.4,2.8-0.2,4.1,0.4c5.5-9.5,13.1-17.7,21.9-22.9l472.1-272.6c4.2-2.3,8.4-3.8,12.7-4 c2.9-0.2,5.8,0,8.4,1.3l61.2,35.3c5.1-0.8,9.9-0.2,14.1,2c-0.1,0-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1l-72.4-41.8 c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.2c-2.2-0.9-4.3-1.4-6.3-1.6c-0.7-0.1-1.5-0.1-2.3,0c-1.3,0-2.5,0-3.7,0.2 c-1.5,0.2-3.1,0.6-4.7,1.1c-0.5,0.2-1.1,0.3-1.6,0.5c-2.2,0.8-4.5,1.8-6.8,3L236.9,423.6c-7.1,4.3-13.4,10.2-18.6,17.1 c-3,4-5.6,8.3-7.8,12.8C211.1,452.2,212.2,451.2,213.7,450.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M204.9,468.7c-0.1,0.4-0.2,0.7-0.3,1.1c-0.2,0.8-0.4,1.5-0.6,2.3c-0.5,2.8-0.9,5.6-1.1,8.4 C203.1,476.5,203.9,472.6,204.9,468.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M205.6,465.8c1.2-4,2.7-7.9,4.7-12.1C208.4,457.7,206.8,461.7,205.6,465.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M711.8,155.7c3.8-2.1,8.3-3.7,12.7-4C720.2,151.9,716,153.4,711.8,155.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M202.9,480.6c-0.1,2,0.9,4,2.7,5C203.9,484.6,202.8,482.6,202.9,480.6L202.9,480.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M223.3,452.8c-0.2,0.4-0.5,0.7-0.8,1.1l0.2,0.1C222.9,453.6,223,453.1,223.3,452.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M725.7,156.9C725.6,156.9,725.6,156.9,725.7,156.9C725.6,156.9,725.6,156.9,725.7,156.9 C725.7,156.9,725.7,156.9,725.7,156.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M719.5,158.2c0.6-0.2,1.1-0.4,1.7-0.6C720.7,157.8,720.1,158,719.5,158.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M783.2,192c1.2-0.6,2.5-1.2,3.7-1.7l-46.6-26.9l46.5,26.9C785.6,190.7,784.4,191.4,783.2,192z"
}), React.createElement("path", {
  className: "st0",
  d: "M296.2,476c-4,4.1-7.5,9-10.7,14.3l0,0C288.7,485,292.3,480.1,296.2,476z"
}), React.createElement("path", {
  className: "st0",
  d: "M228.9,445.3c1-1.2,1.8-2.6,2.9-3.7C230.7,442.8,229.9,444.1,228.9,445.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M239.7,428.3c-8.8,5.2-16.4,13.5-21.9,22.9c0,0,0,0,0,0C223.3,441.9,230.8,433.7,239.7,428.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M733,152.9c-2.7-1.3-5.6-1.5-8.4-1.3C727.3,151.5,730.1,151.7,733,152.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M794.2,188.3L733,152.9L794.2,188.3C794.2,188.3,794.2,188.3,794.2,188.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M217.8,451.2c0.1,0,0.1,0,0.2,0l4.6,2.6c0.2-0.4,0.5-0.7,0.8-1.1c1.7-2.7,3.6-5,5.6-7.4c1-1.2,1.8-2.6,2.9-3.7 c3.3-3.4,6.9-6.4,10.7-8.7l472.1-272.5c1.5-0.8,3.2-1.6,5-2.3c0.6-0.2,1.2-0.4,1.7-0.6c1.5-0.4,2.9-0.7,4.4-0.8c0,0,0,0,0,0 c0,0,0,0,0,0c1.6-0.1,3.2,0.1,4.6,0.8l10,5.8l46.6,26.9c2.5-1,4.9-1.7,7.3-2L733,152.9c-2.9-1.2-5.7-1.5-8.4-1.3 c-4.4,0.4-8.9,2-12.7,4L239.7,428.3C230.8,433.7,223.3,441.9,217.8,451.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M275.3,852.1v-0.3c0,0,0-0.1,0-0.1v-39.2c0-0.2-0.1-0.4-0.1-0.6V565.7l-61.5-35.5l0,279.7 c0.5,6.7,2.1,10.6,6,13.5l55.9,32.2C275.5,854.4,275.3,853.2,275.3,852.1z"
}), React.createElement("polygon", {
  className: "st2",
  points: "213.7,530.3 213.8,810 213.7,530.3  "
}), React.createElement("polygon", {
  className: "st2",
  points: "213.7,530.2 213.7,530.3 275.2,565.7 275.2,565.7  "
}), React.createElement("polygon", {
  className: "st2",
  points: "213.7,530.2 213.7,530.2 213.7,530.3 213.7,530.3  "
}), React.createElement("path", {
  className: "st0",
  d: "M213.8,832.5l72.2,41.7c0,0-0.1-0.1-0.1-0.1L213.8,832.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M202.8,520.8l0.1,289.5L202.8,520.8C202.8,520.8,202.8,520.8,202.8,520.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.5,874.4c-4-2.5-6.9-6.4-8.8-11.3l-61.2-35.3c-6-4.5-7.7-10.7-8.2-17.9c0-94.3,0-188.6,0-282.9l-2.7-1.6 c-1.7-1-2.7-2.8-2.7-4.7l0,289.4c0.5,7,2,15.8,10.9,22.2l72,41.6c0,0,0.1,0.1,0.1,0.1l0.2,0.1C286.3,874.4,286.4,874.4,286.5,874.4 z"
}), React.createElement("path", {
  className: "st0",
  d: "M202.8,520.8C202.8,520.8,202.8,520.8,202.8,520.8C202.8,520.8,202.8,520.8,202.8,520.8L202.8,520.8z"
}), React.createElement("polygon", {
  className: "st0",
  points: "275.3,559.5 275.3,559.5 213.7,524 213.7,524  "
}), React.createElement("path", {
  className: "st0",
  d: "M208.3,520.9C208.3,520.8,208.3,520.8,208.3,520.9c0-1.8,0-3.7,0-5.5c-1,0-1.9,0.2-2.8,0.7 c-1.7,1-2.7,2.7-2.7,4.7v0c0,1.9,1.1,3.7,2.7,4.7l2.7,1.6C208.3,525,208.3,522.9,208.3,520.9L208.3,520.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M213.7,524l-5.4-3.1c0,0,0,0,0,0L213.7,524L213.7,524z"
}), React.createElement("polygon", {
  className: "st0",
  points: "275.3,553.2 213.7,517.7 213.7,524 275.3,559.5  "
}), React.createElement("path", {
  className: "st0",
  d: "M213.7,524l0-6.3l-2.7-1.6c-0.8-0.5-1.8-0.7-2.7-0.7c0,1.8,0,3.6,0,5.4L213.7,524z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.3,851.9C275.3,851.9,275.3,851.9,275.3,851.9l0,0.2c0,1.1,0.2,2.3,0.3,3.6l-55.9-32.2l56.1,32.4 C275.6,854.5,275.4,853.3,275.3,851.9C275.3,851.9,275.3,851.9,275.3,851.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M208.3,527.1c0,94.2,0,188.6,0,282.9C208.3,715.7,208.3,621.4,208.3,527.1L208.3,527.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M219.8,823.4c-3.8-2.9-5.5-6.8-6-13.5l-0.1-279.7l-5.4-3.1c0,94.3,0,188.6,0,282.8c0.5,7.1,2.2,13.4,8.2,17.9 l61.2,35.3c-0.9-2.2-1.5-4.7-1.8-7.3L219.8,823.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.2,562.6c0-0.1,0.1-0.2,0.1-0.3v-2.9L213.7,524l0,6.3l61.5,35.5V562.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M208.3,520.9L208.3,520.9c-0.1,2.1,0,4.2,0,6.3l0,0C208.3,525,208.3,522.9,208.3,520.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M213.7,530.2l0-6.3l-5.4-3.1c0,2.1,0,4.2,0,6.3L213.7,530.2L213.7,530.2L213.7,530.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M821.1,543.1C821.1,543.1,821.1,543.1,821.1,543.1c-0.5,10.2-4,21.3-9.9,31.6 C817.2,564.4,820.7,553.2,821.1,543.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M818.9,547.2c-1,0.7-2.1,1.1-3.2,1.1c-0.2,0-0.4-0.1-0.6-0.1c-1.2,8-4.2,16.2-8.5,23.7 c-5.7,9.9-13.6,18.5-22.3,23.5L312.1,868.1c-6.9,4-13.2,5-18.4,3.6c-0.1,0.3,0,0.7-0.2,1c-1.1,1.6-2.8,2.4-4.5,2.4 c-0.8,0-1.6-0.3-2.4-0.6c0.2,0.2,0.4,0.4,0.7,0.5c3.3,1.9,7,2.9,10.9,2.9c5.2,0,10.9-1.7,16.7-5.1L787,600.2 c9.2-5.3,17.8-14.4,24.2-25.5c5.9-10.3,9.5-21.4,9.9-31.7c0,0,0,0,0,0C821,544.7,820.3,546.2,818.9,547.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.5,857.3c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0C281.4,857.2,281.5,857.2,281.5,857.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M288.9,869.6l-11.3-6.5c1.9,4.9,4.8,8.8,8.8,11.3c0.8,0.4,1.6,0.6,2.4,0.6c1.8,0,3.5-0.9,4.5-2.4 c0.2-0.3,0.1-0.6,0.2-1c-1.3-0.4-2.6-0.8-3.8-1.4C289.6,870.1,289.2,869.8,288.9,869.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.6,866.4c-0.4-0.5-0.8-1.1-1.2-1.7C284.9,865.3,285.2,865.9,285.6,866.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.1,859.6c0.3,1,0.6,1.9,1,2.8C282.8,861.5,282.4,860.6,282.1,859.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M289.9,870.2c-0.7-0.4-1.3-1-1.9-1.5c0.3,0.3,0.6,0.6,0.9,0.9C289.2,869.8,289.6,870.1,289.9,870.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.4,857.1c-0.2,0-0.4,0.2-0.7,0.2c-0.6,0-1.1-0.1-1.6-0.3c-2.2-0.7-3.7-2.7-3.8-5c0,0,0,0,0,0.1 c0.1,1.4,0.3,2.6,0.5,3.8l6.3,3.6c-0.2-0.7-0.4-1.3-0.6-2.1C281.5,857.2,281.4,857.2,281.4,857.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M288,868.7c-0.8-0.7-1.6-1.4-2.4-2.3c-0.4-0.5-0.8-1.1-1.2-1.7c-0.5-0.7-0.9-1.5-1.3-2.3 c-0.4-0.9-0.7-1.9-1-2.8c0-0.1,0-0.1-0.1-0.2l-6.3-3.6c0.4,2.6,1,5.1,1.8,7.3l11.3,6.5C288.6,869.4,288.3,869,288,868.7z"
}), React.createElement("polygon", {
  className: "st0",
  points: "286.3,853.2 286.3,853.2 448.6,617.9 522.5,639.7 448.6,617.9  "
}), React.createElement("polygon", {
  className: "st0",
  points: "652.3,500.3 652.3,500.3 576.9,609.7  "
}), React.createElement("path", {
  className: "st0",
  d: "M292,865.1c0.1,0.1,0.3,0.1,0.4,0.1c-1.5-1-2.8-2.4-3.8-4.2C289.4,862.6,290.5,863.9,292,865.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M808.3,553c-0.3,1.2-0.5,2.5-0.9,3.7C807.8,555.5,808,554.3,808.3,553z"
}), React.createElement("path", {
  className: "st0",
  d: "M550.9,634.8c-3.1,1.8-6.2,3.1-9.2,4.1C544.7,637.9,547.8,636.6,550.9,634.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M529.9,640.8c-2.6-0.1-5-0.4-7.4-1.1C524.9,640.5,527.3,640.8,529.9,640.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M539,639.6c-2.3,0.6-4.6,0.9-6.8,1C534.4,640.6,536.6,640.2,539,639.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.4,853.7c0.3,2.8,1,5.1,1.9,7C287.3,858.7,286.7,856.4,286.4,853.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M809.8,546.8c-0.3,2-1,4.1-1.6,6.2c-0.3,1.3-0.5,2.4-0.9,3.7c-1.4,4.2-3.2,8.4-5.6,12.6 c-5.4,9.3-12.8,17.2-20.3,21.5L309.4,863.3c-6.5,3.8-12.7,4.6-16.7,2.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.1 c0.1,0.1,0.1,0.1,0.2,0.2c2,1.5,2.4,4.2,1.5,6.4c5.2,1.4,11.5,0.4,18.4-3.6l472.1-272.6c8.7-5,16.5-13.6,22.3-23.5 c4.3-7.5,7.3-15.8,8.5-23.7c-0.3,0-0.6-0.1-0.9-0.1L809.8,546.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M288.5,861c-0.1-0.1-0.1-0.2-0.2-0.3c-1-1.9-1.6-4.2-1.9-7c0-0.2-0.1-0.3-0.1-0.4l0-0.1c0,0,0,0,0,0l-1.1,1.6 c-0.9,1.3-2.3,2-3.8,2.2c0,0.1,0,0.2,0,0.3c0.2,0.7,0.4,1.4,0.6,2.1l9.5,5.5c0.1,0.1,0.2,0.1,0.4,0.1 C290.5,863.9,289.4,862.6,288.5,861z"
}), React.createElement("path", {
  className: "st0",
  d: "M292.2,865.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.4-0.1l-9.5-5.5c0,0.1,0,0.1,0,0.2 c0.3,1,0.6,2,1,2.8c0.4,0.8,0.8,1.6,1.3,2.3c0.4,0.6,0.7,1.2,1.2,1.7c0.7,0.8,1.5,1.6,2.4,2.3c0.6,0.5,1.2,1.1,1.9,1.5 c1.2,0.7,2.4,1.1,3.8,1.4C294.6,869.4,294.2,866.8,292.2,865.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.1,859.4L282.1,859.4c-0.2-0.7-0.4-1.3-0.6-2.1C281.6,858.1,281.9,858.7,282.1,859.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M288,868.7c-0.9-0.7-1.7-1.5-2.4-2.3C286.4,867.3,287.2,868,288,868.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.1,859.6c0-0.1,0-0.1,0-0.2l0,0C282.1,859.5,282.1,859.5,282.1,859.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.2,862.4c0.4,0.8,0.8,1.6,1.3,2.3C284,864,283.5,863.2,283.2,862.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.2,565.7v246.2c0,0.2,0.1,0.4,0.1,0.6v39.2c0,0,0,0.1,0,0.1L275.2,565.7L275.2,565.7z"
}), React.createElement("polygon", {
  className: "st0",
  points: "275.2,565.7 275.2,565.7 275.2,565.7  "
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,811.8L280.7,811.8c0,10.1,0,20.2,0,30.3l0,0V811.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,842.1c0-10.1,0-20.2,0-30.3l0,0.1V568.3l-1.5-0.5c-0.2-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.5-0.1-0.7-0.2 l-2.8-1.6l0.1,286.1c0,0,0,0,0,0.1c-0.1-1.2,0.3-2.3,0.9-3.3L280.7,842.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.3,562.6v-0.3C275.3,562.5,275.2,562.5,275.3,562.6l-0.1,3.1v0l2.8,1.6c0.2,0.1,0.4,0.1,0.7,0.2 C276.7,566.7,275.3,564.8,275.3,562.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.4,857.1C281.4,857.1,281.4,857,281.4,857.1c-0.3-1.7-0.6-3.4-0.7-5.3 C280.9,853.6,281.1,855.4,281.4,857.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,842.1c0,3.2,0,6.4,0,9.6L280.7,842.1L280.7,842.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,842.1l-4.5,6.5c-0.6,0.9-1,2.1-0.9,3.3c0.1,2.3,1.6,4.4,3.8,5c0.5,0.2,1.1,0.3,1.6,0.3 c0.2,0,0.4-0.1,0.7-0.2c-0.3-1.7-0.5-3.5-0.7-5.3C280.7,848.5,280.7,845.3,280.7,842.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M443.1,616.3L286.1,843.9l0,7.8c0,0.5,0.1,0.9,0.2,1.5l162.2-235.3L443.1,616.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,843.9l-5.4,7.8c0.1,1.9,0.4,3.6,0.7,5.3c1.5-0.2,2.9-0.9,3.8-2.2l1.1-1.6c-0.1-0.5-0.2-0.9-0.2-1.5 L286.1,843.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,811.8C286.1,811.8,286.1,811.7,286.1,811.8l0,22.5l116.6-169.2L286.1,834.2V811.8z"
}), React.createElement("polygon", {
  className: "st0",
  points: "437.5,614.7 437.6,614.7 361.1,592.1  "
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,842.1l5.4-7.8l0-22.6c0-0.2,0-0.4,0-0.6V569.9l-5.4-1.6c0,81.2,0,162.3,0,243.5l0,0V842.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,568.3v243.6l0-0.1C280.7,730.6,280.7,649.5,280.7,568.3L280.7,568.3z"
}), React.createElement("polygon", {
  className: "st0",
  points: "437.5,614.7 437.6,614.7 402.8,665.1 286.1,834.3 286.1,843.9 443.1,616.3 437.6,614.7  "
}), React.createElement("polygon", {
  className: "st0",
  points: "280.7,842.1 280.7,851.7 286.1,843.9 286.1,834.3  "
}), React.createElement("path", {
  className: "st0",
  d: "M821.1,253.7c0,1.1-0.3,2.2-0.9,3.1c-1.6,2.3-2.9,4.2-4.5,6.5l0,273.9l1.5,0.5c2.4,0.7,3.9,2.9,3.9,5.4 c0,0,0-0.1,0-0.1V253.7c0.1-0.1,0-0.2,0-0.2V253.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M652.3,500.3l157.1,46.4c0,0,0,0,0,0L652.3,500.3L652.3,500.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M809.8,546.8C809.8,546.8,809.8,546.8,809.8,546.8l-0.4-0.1c0,0,0,0,0,0L809.8,546.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M815,548.2c0.2,0,0.4,0.1,0.6,0.1c1.1,0,2.3-0.4,3.2-1.1c1.4-1,2.1-2.6,2.2-4.2c0-2.5-1.5-4.6-3.9-5.4 l-1.5-0.5l0,5.7C815.6,544.6,815.3,546.4,815,548.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M652.3,500.3L652.3,500.3L652.3,500.3l157.2,46.4c0.2-1.3,0.7-2.8,0.8-4.1v-1.4l-154.7-45.7L652.3,500.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M810.2,541.3v1.4c-0.1,1.3-0.6,2.7-0.8,4.1l0.4,0.1c0,0,0,0,0,0l4.3,1.3c0.3,0.1,0.6,0.1,0.9,0.1 c0.3-1.8,0.6-3.6,0.6-5.4L810.2,541.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M702.4,427.6l-0.5-0.3c-2,3.8-6.5,10.4-14.3,21.7l27.3-39.6C703.9,425.5,702.5,427.4,702.4,427.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "658.8,490.9 658.8,490.9 669.6,494  "
}), React.createElement("path", {
  className: "st0",
  d: "M810.3,271.2L810.3,271.2c-3.1,4.5-6.4,9.3-9.4,13.6L810.3,271.2z"
}), React.createElement("polygon", {
  className: "st0",
  points: "810.2,535.6 810.2,457.3 810.2,535.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M810.3,271.2L810.3,271.2l0,186.1l0,78.3l5.5,1.6l0-273.9C813.8,266,812.1,268.6,810.3,271.2L810.3,271.2z"
}), React.createElement("polygon", {
  className: "st0",
  points: "810.2,535.6 669.6,494 658.8,490.9 655.5,495.6 810.2,541.3 810.2,535.6 810.2,535.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "810.2,541.3 815.7,542.9 815.7,537.2 810.2,535.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M821.1,213.5c-0.5-10.6-4.7-18.8-11.9-22.9c-0.2-0.1-0.5-0.1-0.7-0.3C816.5,195.1,820.7,203.1,821.1,213.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M810.3,197.2c-0.1,0.3-0.5,0.4-0.7,0.6c2.6,2.6,4.5,6.2,5.4,10.8c0.8-0.1,1.5-0.3,2.3-0.1 c2.3,0.7,3.8,2.8,3.8,5.2v-0.3c-0.5-10.4-4.6-18.4-12.6-23.2c-0.1,0-0.1,0-0.2-0.1C810.6,191.8,811.5,194.7,810.3,197.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M781.5,192.8L309.4,465.4c-4.6,2.7-9,6.3-13.2,10.6c4-4.2,8.5-7.8,13.1-10.6L781.5,192.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M781.5,192.7L781.5,192.7c0.6-0.3,1.1-0.5,1.7-0.8C782.7,192.3,782.1,192.4,781.5,192.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M294.6,486.4c1.6-2.2,3.4-4.3,5.2-6.3C297.9,482.1,296.2,484.2,294.6,486.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M303.3,476.8c0.8-0.7,1.5-1.5,2.3-2.1C304.7,475.4,304,476.2,303.3,476.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M792.1,194.3c0.4-0.1,0.8-0.2,1.2-0.3l-0.1-0.1C792.8,194,792.4,194.1,792.1,194.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M784.3,197.5c1.9-1.1,3.7-1.8,5.4-2.5C787.8,195.7,786,196.5,784.3,197.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M294.6,486.5c-1.5,2.1-3,4.3-4.3,6.6l0,0C291.6,490.8,293,488.6,294.6,486.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M805.3,194.7L805.3,194.7c0.5,0.2,0.9,0.4,1.2,0.7c1.1,0.6,2.1,1.5,3.1,2.5c0.2-0.3,0.5-0.3,0.7-0.6 c1.2-2.5,0.3-5.4-1.9-6.9c-4.2-2.2-9-2.8-14.1-2l11.2,6.5L805.3,194.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M803,194c1.2,0.3,2.4,0.7,3.5,1.3c-0.4-0.2-0.7-0.4-1.2-0.6l-0.1-0.1l-1-0.4C803.8,194.1,803.4,194.2,803,194z "
}), React.createElement("path", {
  className: "st0",
  d: "M797.7,193.4c1,0,1.9,0,2.8,0.1C799.5,193.4,798.6,193.3,797.7,193.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M793.3,194c0.7-0.1,1.3-0.3,2-0.4c-0.7,0.1-1.4,0.2-2.1,0.4L793.3,194z"
}), React.createElement("path", {
  className: "st0",
  d: "M781.5,192.8L309.3,465.4c-4.6,2.8-9.1,6.3-13.1,10.6c-3.9,4.2-7.5,9-10.7,14.3l4.7,2.7 c1.3-2.3,2.7-4.5,4.3-6.6c0,0,0,0,0-0.1c1.6-2.2,3.3-4.3,5.2-6.3c1.1-1.2,2.3-2.2,3.5-3.3c0.8-0.7,1.5-1.5,2.3-2.1 c2.1-1.8,4.3-3.3,6.6-4.6l472.1-272.6c1.7-1,3.6-1.8,5.4-2.5c0.8-0.3,1.6-0.5,2.4-0.7c0.4-0.1,0.7-0.2,1.1-0.3l-6.3-3.6 c-1.2,0.5-2.4,1-3.7,1.7C782.7,192.3,782.1,192.5,781.5,192.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M805.3,194.7l0.1,0.1l-11.2-6.5c0,0,0,0,0,0L805.3,194.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M795.3,193.6c0.8-0.1,1.6-0.2,2.4-0.2c0.9,0,1.8,0,2.8,0.1c0.9,0.1,1.8,0.3,2.6,0.5c0.4,0.1,0.8,0.1,1.2,0.2 l1,0.4l-11.1-6.4c-2.4,0.4-4.8,1-7.3,2l6.3,3.6C793.9,193.8,794.6,193.7,795.3,193.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M793,199.6c0.8-0.2,1.6-0.5,2.4-0.6C794.5,199.2,793.8,199.4,793,199.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M294.6,496.3c-1.9,3.3-3.1,6.5-4.4,9.7c0,0.1-0.1,0.2-0.1,0.3C291.4,503,292.7,499.6,294.6,496.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M309.2,478.7c-5.5,4.5-10.5,10.5-14.5,17.6C298.6,489.3,303.8,483.2,309.2,478.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M802.1,199.3c-0.3-0.1-0.7-0.1-1-0.2c0.9,0.2,1.8,0.4,2.6,0.9l-0.4-0.2c0,0-0.1,0-0.1,0L802.1,199.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M797,198.8c0.8-0.1,1.7-0.1,2.4,0C798.6,198.8,797.8,198.7,797,198.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M788.1,201.6c0.9-0.5,1.8-0.9,2.7-1.3C789.9,200.8,789,201.2,788.1,201.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M803.3,199.8l0.4,0.2c3.6,2.1,5.8,6.6,6.3,12.4l1.2-1.7c0.9-1.3,2.3-1.9,3.8-2.1c-0.9-4.6-2.8-8.3-5.4-10.8 C808.1,199.8,805.7,200.7,803.3,199.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M288.4,510.8c-0.8,2.7-1.2,5.4-1.6,8l0.1,0C287.3,516.2,287.6,513.5,288.4,510.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M789.7,195c-1.8,0.7-3.6,1.4-5.4,2.5L312.1,470.1c-2.3,1.4-4.5,2.9-6.6,4.6c-0.8,0.6-1.5,1.4-2.3,2.1 c-1.2,1.1-2.4,2.1-3.5,3.3c-1.8,2-3.6,4.1-5.2,6.3c0,0,0,0,0,0.1c-1.5,2.1-3,4.3-4.3,6.6l0.1,0.1c2.5,1.4,3.4,4.5,2.2,7.1 c-1,2-1.5,3.9-2.3,5.9c1.3-3.2,2.5-6.5,4.4-9.7c4.1-7.1,9.1-13.1,14.5-17.6c1.8-1.5,3.7-2.9,5.6-4L787,202.2 c0.4-0.2,0.8-0.3,1.2-0.5c0.9-0.5,1.8-0.9,2.7-1.3c0.7-0.3,1.4-0.5,2.1-0.7c0.8-0.3,1.6-0.4,2.4-0.6c0.5-0.1,1.1-0.2,1.6-0.2 c0.8-0.1,1.6-0.1,2.4,0c0.6,0.1,1.2,0.2,1.7,0.3c0.3,0.1,0.7,0,1,0.2l1.1,0.5c0,0,0.1,0,0.1,0l-10-5.8c-0.4,0.1-0.8,0.1-1.2,0.3 C791.3,194.5,790.5,194.7,789.7,195z"
}), React.createElement("path", {
  className: "st0",
  d: "M803,194c-0.9-0.2-1.7-0.4-2.6-0.5c-0.9-0.1-1.8-0.2-2.8-0.1c-0.8,0-1.6,0.1-2.4,0.2c-0.6,0.1-1.3,0.3-2,0.4 l10,5.8c2.4,0.9,4.8,0,6.2-2c-0.9-0.9-1.9-1.8-3.1-2.5C805.5,194.7,804.2,194.4,803,194z"
}), React.createElement("path", {
  className: "st0",
  d: "M299.8,480.1c1.1-1.2,2.3-2.2,3.5-3.3C302.1,477.9,300.9,479,299.8,480.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M789.7,195c0.8-0.3,1.6-0.5,2.4-0.7C791.3,194.5,790.5,194.7,789.7,195z"
}), React.createElement("path", {
  className: "st0",
  d: "M305.5,474.7c2.1-1.7,4.3-3.3,6.6-4.6C309.8,471.4,307.7,473,305.5,474.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M294.6,486.5C294.6,486.4,294.6,486.4,294.6,486.5C294.6,486.4,294.6,486.4,294.6,486.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M795.3,193.6c0.8-0.1,1.6-0.2,2.4-0.2C796.9,193.4,796.1,193.5,795.3,193.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M803,194c-0.8-0.2-1.7-0.4-2.6-0.5C801.3,193.6,802.2,193.8,803,194z"
}), React.createElement("path", {
  className: "st2",
  d: "M550.9,598.8c-7,4.1-14,5.3-20.2,3.5L286.1,530v28.6l45,13.3l116.7,34.5l77.7,23c5.7,1.7,12.5,0.3,19.8-4 c8-4.6,15.8-12.1,22.4-21.8l77.7-112.7l57.8-83.8c1.8-2.7,3.8-5.6,6.2-9l100.7-146v-20.8L568.7,581.7 C563.5,589.2,557.3,595.1,550.9,598.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M525.6,629.3l-77.7-23c0,0,0,0,0.1,0L525.6,629.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M645.6,490.9l-77.7,112.7C602.5,553.3,627.4,517.2,645.6,490.9C645.6,490.9,645.6,490.9,645.6,490.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M447.9,606.3l-116.7-34.5L447.9,606.3C447.9,606.3,447.9,606.3,447.9,606.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M448,606.4C447.9,606.4,447.9,606.3,448,606.4c-0.1,0-0.1,0-0.1,0L448,606.4z"
}), React.createElement("path", {
  className: "st2",
  d: "M693.4,421.5l0.4,0.3c1.6-2.9,4.6-7.5,9.5-14.6l-57.8,83.8c0,0,0,0,0,0C689.8,426.8,693.3,421.7,693.4,421.5z"
}), React.createElement("path", {
  className: "st2",
  d: "M645.6,490.8C645.6,490.9,645.6,490.9,645.6,490.8C645.6,490.9,645.6,490.9,645.6,490.8 C645.6,490.9,645.6,490.9,645.6,490.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M545.4,589.4c-4.3,2.5-8.4,3.4-11.6,2.4l-246.9-73c-0.2,1.4-0.7,2.8-0.8,4.2v1.3L532.2,597 c4.8,1.4,10.4,0.3,15.9-3c5.6-3.2,11.2-8.5,16-15.5l246.1-356.8v-7.9c0-0.5-0.1-0.9-0.2-1.4L559.7,575.5 C555.4,581.7,550.5,586.4,545.4,589.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.3,521.9c0,0.4-0.2,0.7-0.2,1.1c0.1-1.4,0.6-2.8,0.8-4.2l0,0C286.8,519.8,286.4,520.9,286.3,521.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M817.3,208.6c-0.8-0.2-1.6-0.1-2.3,0.1c0.3,1.6,0.6,3.3,0.7,5.2v34.7c0.6,0,1.1-0.2,1.6,0 c2.3,0.7,3.7,2.7,3.8,5V253v-39.2C821.1,211.4,819.6,209.3,817.3,208.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,528.1c-0.9,0-1.9-0.3-2.7-0.7l-2.7-1.6v27.4v0l5.5,3.2V528.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M276,559.9l-0.7-0.4v0L276,559.9C276,559.9,276,559.9,276,559.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M277.4,558.2c0.9-0.7,2.1-0.9,3.3-0.9v-0.9l-5.5-3.2v6.3l0.7,0.4C276.4,559.3,276.8,558.7,277.4,558.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M276,559.9l-0.7-0.4v2.9C275.3,561.5,275.6,560.7,276,559.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M541.7,638.9c-0.9,0.3-1.8,0.5-2.7,0.8C539.9,639.4,540.8,639.2,541.7,638.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M530.5,640.9c0.5,0,1.1-0.2,1.6-0.2c-0.8,0-1.5,0.2-2.3,0.2C530.1,640.8,530.3,640.9,530.5,640.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M647,498.3c-17.9,26-42,60.9-74.7,108.3c-7.3,10.5-15.7,18.5-24.2,23.4c-8.4,4.9-16.9,6.6-24.1,4.5 c-32.2-9.5-55.5-16.4-72.6-21.5c-0.2,0.5-0.3,1.1-0.6,1.6l-2.2,3.2l73.9,21.8c2.4,0.7,4.8,1,7.4,1.1c0.7,0,1.5-0.1,2.3-0.2 c2.2-0.1,4.5-0.5,6.8-1c0.9-0.2,1.8-0.5,2.7-0.8c3-1,6.1-2.3,9.2-4.1c9.4-5.4,18.4-14.1,26-25.1l75.4-109.4l-3.8-1.1 C648,499,647.5,498.7,647,498.3z"
}), React.createElement("polygon", {
  className: "st0",
  points: "361.1,592.1 286.1,569.9 286.1,569.9  "
}), React.createElement("rect", {
  x: 286.1,
  y: 569.9,
  className: "st0",
  width: 0,
  height: 0
}), React.createElement("path", {
  className: "st0",
  d: "M347.5,582.4c-15.6-4.6-35.7-10.6-61.4-18.1v0L347.5,582.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,564.2c-0.1,0-0.2-0.1-0.4-0.1c0,0,0,0,0,0L286.1,564.2L286.1,564.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.7,564.1C285.7,564.1,285.8,564.1,285.7,564.1c-1.7-0.5-3.2-1-5-1.5l-4.7-2.7c0,0,0,0,0,0l4.7,2.7 L285.7,564.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,557.3c-1.2,0-2.3,0.2-3.3,0.9c-0.6,0.5-1,1.1-1.4,1.7l4.7,2.7V557.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M278.7,567.5c0.2,0.1,0.3,0.3,0.5,0.3l1.5,0.5V568C280,568,279.3,567.8,278.7,567.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,562.6l-4.7-2.7c-0.4,0.7-0.7,1.6-0.7,2.4v0.3c0,2.2,1.4,4,3.4,4.9c0.7,0.3,1.3,0.5,2,0.5V562.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M443.1,616.3l5.5,1.6l2.2-3.2c0.3-0.5,0.4-1,0.6-1.6c-1.8-0.5-3.5-1-5.1-1.5L443.1,616.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,564.2l0,5.7l75,22.2l76.4,22.6l3.2-4.7c-75.7-22.4,8.9,2.6-93.3-27.6L286.1,564.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,569.9l0-5.7l-0.4-0.1c-0.4,1.3-1.1,2.5-2.3,3.2c-0.8,0.5-1.8,0.7-2.7,0.7c0,0,0,0-0.1,0 c0,0.1,0,0.2,0,0.3L286.1,569.9L286.1,569.9L286.1,569.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.4,567.3c1.2-0.7,1.9-1.9,2.3-3.2l-5.1-1.5c0,1.8,0,3.6,0,5.4c0,0,0,0,0.1,0 C281.7,568,282.6,567.8,283.4,567.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,568L280.7,568l0,0.3h0C280.7,568.2,280.7,568.1,280.7,568z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,568L280.7,568c0-1.8,0-3.6,0-5.4V568z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.8,610l-3.2,4.7l5.5,1.6l3.2-4.7C444.4,611,442.6,610.5,440.8,610z"
}), React.createElement("path", {
  className: "st0",
  d: "M715,409.4c12.4-18,37-53.7,85.9-124.6L715,409.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M687.7,449l-28.9,41.8l0,0l26.5-38.4C686.2,451.2,686.8,450.2,687.7,449z"
}), React.createElement("path", {
  className: "st0",
  d: "M668.7,467l4.3-6.2l137.3-199.2v0C625.8,529.1,744,357.7,668.7,467z"
}), React.createElement("path", {
  className: "st0",
  d: "M817.3,248.5c-0.5-0.2-1.1,0-1.6,0v5.2l0-0.1l0,9.6c1.5-2.2,2.9-4.2,4.5-6.5c0.6-0.9,0.9-2,0.9-3.1v-0.2 C821,251.2,819.6,249.2,817.3,248.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M810.3,261.6l5.5-7.9l0,0.1C813.8,256.4,812.1,259,810.3,261.6L810.3,261.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M647,498.3c0.5,0.3,0.9,0.7,1.5,0.9l3.8,1.1l3.3-4.7l-5.5-1.6C649.1,495.4,648.1,496.9,647,498.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M668.7,467c-4.4,6.4-9.5,13.8-15.4,22.3l5.5,1.6l0,0l0,0l28.9-41.8c7.8-11.3,12.3-17.9,14.3-21.7l0.5,0.3 c0.1-0.1,1.4-2.1,12.5-18.2l85.9-124.6c2.9-4.3,6.3-9.1,9.4-13.6l0-9.6L673,460.8L668.7,467z"
}), React.createElement("path", {
  className: "st0",
  d: "M810.3,261.6l0,9.6c1.8-2.6,3.6-5.2,5.5-7.9l0-9.6L810.3,261.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M655.5,495.6l3.3-4.7l-5.5-1.6c-1.1,1.6-2.1,3.1-3.3,4.7L655.5,495.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M810,212.4c0,0.5,0.2,0.9,0.2,1.4v7.9l5.5-7.9c-0.1-1.9-0.4-3.6-0.7-5.2c-1.5,0.2-2.9,0.8-3.8,2.1L810,212.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,524.3V523c0,0.4-0.3,0.8-0.4,1.2L286.1,524.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.9,518.8L286.9,518.8c-0.2,1-0.5,2.1-0.6,3.1C286.4,520.9,286.8,519.8,286.9,518.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M451.4,613.1c17.1,5.1,40.4,11.9,72.6,21.5C489.7,624.4,467,617.7,451.4,613.1 C451.4,613.1,451.4,613.1,451.4,613.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M347.5,582.4l31,9.2c-17.9-5.3-46.2-13.7-92.3-27.3l0,0C311.8,571.8,331.8,577.7,347.5,582.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.8,564.1c0.1,0,0.2,0.1,0.4,0.1l0,0C286,564.2,285.9,564.1,285.8,564.1L285.8,564.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.7,562.6c1.8,0.5,3.3,1,5,1.5v0C284,563.6,282.5,563.1,280.7,562.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M446.3,611.6L446.3,611.6c1.6,0.5,3.4,1,5.1,1.5c0,0,0,0,0,0C449.6,612.6,447.9,612.1,446.3,611.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.8,610L440.8,610c-37-11-17.4-5.2-62.3-18.4l-31-9.2C449.7,612.6,365.1,587.6,440.8,610z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.8,610c1.8,0.5,3.6,1.1,5.5,1.6l0,0C444.4,611,442.5,610.5,440.8,610L440.8,610z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.2,594c-5.6,3.2-11.1,4.4-15.9,3l-246.1-72.8v5.7l244.5,72.3c6.2,1.8,13.2,0.6,20.2-3.5 c6.5-3.7,12.6-9.6,17.8-17.1l241.6-350.4v-9.5L564.2,578.6C559.3,585.5,553.8,590.8,548.2,594z"
}), React.createElement("path", {
  className: "st0",
  d: "M703.3,407.1l106.9-155v0l-100.7,146C707.2,401.5,705.1,404.4,703.3,407.1z"
}), React.createElement("polygon", {
  className: "st0",
  points: "331.2,571.8 286.1,558.5 286.1,558.5  "
}), React.createElement("path", {
  className: "st0",
  d: "M810.2,231.3v20.8v0l1-1.5c1-1.5,2.7-2.1,4.5-2.1v-34.7l-5.5,7.9V231.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.3,527.5c-0.8,0.4-1.7,0.7-2.6,0.7v28.2l2,1.2l3.4,1v0V530v-5.7l-0.4-0.1 C285.4,525.5,284.6,526.8,283.3,527.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.8,557.5l-2-1.2v0.9c0.5,0,1-0.1,1.5,0.1L282.8,557.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M451.5,609.8c0.4,1.1,0.3,2.2,0,3.3l72.6,21.5c7.3,2.1,15.7,0.4,24.1-4.5c8.5-4.9,16.9-12.9,24.2-23.4 L647,498.3c-0.9-0.7-1.7-1.5-2.1-2.6c-0.5-1.6-0.3-3.5,0.6-4.9c-18.2,26.4-43.1,62.4-77.7,112.7c-6.7,9.6-14.4,17.2-22.4,21.8 c-7.3,4.3-14.2,5.7-19.8,4L448,606.4C449.6,606.9,450.9,608.1,451.5,609.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M451.4,613.1c15.6,4.6,38.3,11.3,72.6,21.5L451.4,613.1C451.4,613.1,451.4,613.1,451.4,613.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M572.4,606.7c32.7-47.4,56.8-82.4,74.7-108.3c0,0,0,0,0,0L572.4,606.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,562.6c0,0,0,0.1,0,0.1v1.5c46.2,13.6,74.4,22,92.3,27.3l45,13.3l17.4,5.1l1-1.5c1.3-1.9,3.7-2.7,6-2.1 l-116.7-34.5l-45-13.3V562.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,562.6v0.1C286.1,562.7,286.1,562.7,286.1,562.6l0-4.1l-3.4-1l0.6,0.3 C285.1,558.9,286.1,560.6,286.1,562.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,564.2v-1.5c0,0.5-0.2,0.9-0.4,1.3C285.9,564.1,286,564.2,286.1,564.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.8,564.1c0.1-0.4,0.3-0.9,0.4-1.3v-0.1c0-2-1-3.8-2.7-4.7l-0.6-0.3l-0.6-0.2c-0.5-0.2-1-0.1-1.5-0.1v5.3 C282.5,563.1,284,563.6,285.8,564.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M451.4,613.1c0.3-1.1,0.4-2.2,0-3.3c-0.6-1.6-1.9-2.9-3.5-3.4l-0.1,0c-2.3-0.6-4.7,0.2-6,2.1l-1,1.5l5.5,1.6 L451.4,613.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M446.3,611.6c1.6,0.5,3.3,1,5.1,1.5c0,0,0,0,0,0L446.3,611.6L446.3,611.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.8,609.9l-17.4-5.1l-45-13.3C423.3,604.8,403.8,599,440.8,609.9L440.8,609.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M446.3,611.6L446.3,611.6l-5.5-1.7l0,0C442.5,610.5,444.4,611,446.3,611.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M693.9,421.7l-0.4-0.3c-0.2,0.2-3.7,5.3-47.9,69.4c1.3-1.9,3.8-2.8,6-2.1l1.7,0.5l15.4-22.3 c75.3-109.2-42.9,62.1,141.6-205.4l0-7.1c-0.1-0.2-0.1-0.5-0.1-0.7v-1.6l-106.9,155C698.4,414.3,695.4,418.8,693.9,421.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M810.2,252.1v1.6c0,0.3,0,0.5,0.1,0.7l0,7.1c1.8-2.6,3.6-5.1,5.4-7.9v-5.2c-1.7,0-3.4,0.6-4.5,2.1L810.2,252.1 z"
}), React.createElement("path", {
  className: "st0",
  d: "M644.9,495.8c0.4,1.1,1.2,1.9,2.1,2.6l3-4.4l3.3-4.7l-1.7-0.5c-2.2-0.6-4.7,0.2-6,2.1c0,0,0,0,0,0 C644.6,492.3,644.4,494.1,644.9,495.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M647,498.3c1-1.5,2-3,3-4.4l0,0L647,498.3C647,498.3,647,498.3,647,498.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M653.3,489.2c5.8-8.5,10.9-15.9,15.4-22.3L653.3,489.2L653.3,489.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M650,494L650,494c1.1-1.6,2.2-3.2,3.3-4.7l0,0L650,494z"
}), React.createElement("path", {
  className: "st2",
  d: "M279.3,503.7c0.3-0.9,0.7-1.8,1-2.7c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.1-0.5,0.2-0.7L218,463.8 c-0.2,0.6-0.6,1.2-0.8,1.8c-0.8,2.2-1.2,4.4-1.7,6.6c-0.4,1.9-0.9,3.8-1.1,5.7l34.9,20.2l27.1,15.6c0.1-0.3,0.2-0.7,0.3-1 C277.3,509.8,278.2,506.8,279.3,503.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M218,463.8l-0.1-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.2-0.1,0.4-0.1,0.6 C217.4,465,217.7,464.5,218,463.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.5,472.3c-0.4,1.9-1.2,3.7-1.4,5.6l0.3,0.2C214.6,476.1,215,474.2,215.5,472.3z"
}), React.createElement("polygon", {
  className: "st2",
  points: "249.2,498.2 256.9,502.6 276.3,513.8 276.3,513.8  "
}), React.createElement("path", {
  className: "st2",
  d: "M280.3,501c-0.4,0.9-0.7,1.8-1,2.7C279.6,502.8,280,501.9,280.3,501z"
}), React.createElement("path", {
  className: "st2",
  d: "M217.1,465.6c0,0.1-0.1,0.2-0.2,0.4c-0.2,0.7-0.5,1.4-0.7,2c-0.4,1.4-0.5,2.8-0.8,4.3 C216,470.1,216.4,467.8,217.1,465.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M216.3,468c-1,3.3-1.9,6.5-2.2,9.8l0,0c0.2-1.9,1-3.7,1.4-5.6C215.8,470.9,215.9,469.4,216.3,468z"
}), React.createElement("path", {
  className: "st2",
  d: "M217.7,463.7c-0.1,0.2-0.1,0.4-0.2,0.6C217.6,464.1,217.7,464,217.7,463.7L217.7,463.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M217.3,465.1c-0.1,0.3-0.2,0.6-0.3,0.9c0-0.1,0.1-0.2,0.2-0.4C217.2,465.5,217.2,465.3,217.3,465.1z"
}), React.createElement("path", {
  className: "st2",
  d: "M276.3,513.9C276.3,513.9,276.3,513.8,276.3,513.9l-19.4-11.2L276.3,513.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M276.6,512.8c0.1-0.4,0.3-0.7,0.3-1.1c0.6-2.7,1.4-5.3,2.3-8C278.2,506.8,277.3,509.8,276.6,512.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.3,501c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2C280.4,500.8,280.4,500.9,280.3,501z"
}), React.createElement("path", {
  className: "st2",
  d: "M279.3,503.7c-0.9,2.6-1.7,5.3-2.3,8c0.8-3.6,1.9-7.2,3.4-10.8c0,0,0,0.1,0,0.1 C280,501.9,279.6,502.8,279.3,503.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M204.9,468.7c0.2-0.9,0.4-1.8,0.7-2.7C205.3,466.8,205.1,467.8,204.9,468.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.4,453.6C210.3,453.6,210.3,453.6,210.4,453.6C210.3,453.6,210.4,453.6,210.4,453.6 C210.4,453.5,210.4,453.5,210.4,453.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M205.6,465.8c0,0,0,0.1,0,0.1c-0.3,0.9-0.5,1.8-0.7,2.7c0,0,0,0,0,0.1C205.1,467.8,205.3,466.8,205.6,465.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.4,453.5C210.4,453.5,210.4,453.5,210.4,453.5c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1 C210.3,453.7,210.4,453.6,210.4,453.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.2,490.9c0.1-0.2,0.3-0.4,0.4-0.6L222.7,454c-0.9,1.6-1.6,3.3-2.4,4.9l62.8,36.3 C283.7,493.7,284.4,492.3,285.2,490.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M205.6,476.1c1.1-0.6,2.3-0.7,3.4-0.5c0.3-2,0.7-4,1.2-6c0.2-0.8,0.4-1.7,0.6-2.5c0.9-3,2-6,3.3-8.9 c0.3-0.6,0.6-1.1,0.9-1.7c0.1-0.2,0.1-0.3,0.2-0.5l0,0c0.8-1.6,1.6-3.2,2.5-4.8c-1.3-0.7-2.7-0.9-4.1-0.4c-1.5,0.4-2.6,1.4-3.3,2.7 c0,0.1-0.1,0.2-0.1,0.2c-2,4.1-3.5,8.1-4.7,12.1c-0.3,1-0.5,1.9-0.8,2.9c-1,3.9-1.7,7.8-2,11.8c0,0,0,0,0,0.1 C203,478.8,204,477.1,205.6,476.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M214.2,458.1c-1.3,2.9-2.4,5.9-3.3,8.9c0,0,0-0.1,0-0.1C211.8,464,212.9,461,214.2,458.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.2,469.7C210.2,469.6,210.2,469.6,210.2,469.7c-0.5,1.9-0.9,3.9-1.2,5.9c0,0,0,0,0,0 C209.3,473.6,209.7,471.6,210.2,469.7z"
}), React.createElement("rect", {
  x: 244.5,
  y: 472.6,
  transform: "matrix(0.4998 -0.8661 0.8661 0.4998 -317.7477 465.9049)",
  className: "st0",
  width: 0,
  height: 71
}), React.createElement("path", {
  className: "st0",
  d: "M209,475.6c-1.2-0.2-2.3-0.1-3.4,0.5c-1.6,0.9-2.6,2.6-2.7,4.5c-0.1,2,0.9,4,2.7,5l2.7,1.6c0-2.1,0-4.2,0-6.3 C208.4,479.1,208.7,477.4,209,475.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M209,475.6c-0.3,1.8-0.6,3.5-0.7,5.3C208.4,479.1,208.7,477.4,209,475.6C209,475.6,209,475.6,209,475.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M213.8,490.3l61.5,35.5v-3.2c0-1,0.2-2,0.3-3L213.7,484L213.8,490.3L213.8,490.3L213.8,490.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M213.7,484l-5.4-3.1c0,2.1,0,4.2,0,6.3l5.4,3.1L213.7,484z"
}), React.createElement("path", {
  className: "st0",
  d: "M220.2,458.9c0.8-1.6,1.5-3.3,2.4-4.9l-0.2-0.1C221.6,455.5,221,457.2,220.2,458.9L220.2,458.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.5,490.3L285.5,490.3c-0.1,0.2-0.3,0.4-0.4,0.6C285.3,490.7,285.4,490.5,285.5,490.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M215,456.4c-0.3,0.6-0.6,1.1-0.9,1.7C214.4,457.6,214.8,457,215,456.4C215,456.5,215,456.5,215,456.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M215.3,456c0.8-1.6,1.6-3.2,2.5-4.8c0,0,0,0,0,0C216.8,452.8,216.1,454.4,215.3,456L215.3,456z"
}), React.createElement("path", {
  className: "st0",
  d: "M215,456.5c-0.3,0.6-0.6,1.1-0.9,1.7c-1.3,2.9-2.3,5.9-3.2,8.8C212,463.4,213.3,460,215,456.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M222.5,453.9l-4.6-2.6c-0.1,0-0.1,0-0.2,0c-0.9,1.6-1.7,3.2-2.5,4.8l5,2.9C221,457.2,221.6,455.5,222.5,453.9z "
}), React.createElement("path", {
  className: "st0",
  d: "M209,475.6c0.1,0,0.1,0,0.2,0.1c0.3-2,0.5-4.1,1-6C209.7,471.6,209.3,473.6,209,475.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M209,475.6c-0.3,1.8-0.6,3.5-0.7,5.3c0.1-1.8,0.6-3.5,0.9-5.2C209.1,475.6,209.1,475.6,209,475.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M288.5,510.6c0.4-1.4,1.1-2.8,1.7-4.2c-0.4,1.1-1.1,2.2-1.5,3.3C288.5,510,288.6,510.3,288.5,510.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M288.4,510.8c0,0,0-0.1,0.1-0.1c0.1-0.3,0.1-0.6,0.2-0.9C288.5,510.1,288.5,510.4,288.4,510.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M283,495.1L283,495.1c0.8-1.4,1.3-2.8,2.2-4.3C284.4,492.3,283.7,493.7,283,495.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M290.3,493L290.3,493c-0.1,0.2-0.3,0.4-0.4,0.6C290,493.4,290.2,493.2,290.3,493z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.6,519.7c-0.1,1-0.3,2-0.3,3c0-1,0.3-1.9,0.8-2.7L275.6,519.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.8,510.7c0.1-0.4,0.2-0.9,0.3-1.3C283,509.8,282.9,510.3,282.8,510.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.1,495.2l4.5,2.6c-0.2,0.3-0.2,0.6-0.4,1c0.8-1.7,1.7-3.5,2.6-5.2c0.1-0.2,0.2-0.4,0.4-0.6l-4.7-2.7 c-0.1,0.2-0.3,0.4-0.4,0.6C284.3,492.3,283.8,493.7,283.1,495.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M290.1,506.4c0-0.1,0.1-0.2,0.1-0.3c-0.5,1.2-1.2,2.4-1.6,3.7C289,508.6,289.7,507.5,290.1,506.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.2,503.9c-0.6,1.6-1.4,3.2-1.9,4.8c-0.8,2.7-1.1,5.5-1.6,8.3l1,0.6l4.1,1.2c0.4-2.7,0.8-5.4,1.6-8 c0.1-0.4,0.1-0.7,0.2-1.1c0.4-1.2,1.1-2.4,1.6-3.7c0.8-1.9,1.3-3.8,2.3-5.9c1.3-2.6,0.3-5.7-2.2-7.1l-0.1-0.1 c-0.1,0.2-0.3,0.4-0.4,0.6C288,496.9,286.6,500.4,285.2,503.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.3,517.4l0.5,0.2l-1-0.6c0,0.1-0.1,0.3-0.1,0.4C281.9,517.4,282.1,517.4,282.3,517.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.8,517c0.4-2.8,0.8-5.6,1.6-8.3c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.4-0.2,0.9-0.3,1.3 C282.2,512.7,282,514.9,281.8,517L281.8,517z"
}), React.createElement("path", {
  className: "st0",
  d: "M289.9,493.6c-1,1.7-1.8,3.4-2.6,5.2c-0.8,1.7-1.3,3.5-2,5.2C286.6,500.4,288,496.9,289.9,493.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.6,517.4C281.7,517.4,281.7,517.4,281.6,517.4c0.1-0.1,0.2-0.3,0.2-0.4l-0.1-0.1 C281.7,517.1,281.7,517.2,281.6,517.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,522.9v0.1c0-0.4,0.2-0.7,0.2-1.1C286.3,522.2,286.2,522.6,286.1,522.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M278,527.4c0.9,0.5,1.8,0.7,2.7,0.7v-5.5l-4.7-2.7c-0.5,0.8-0.8,1.7-0.8,2.7v3.2l0,0L278,527.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,522.7v0.2c0-0.3,0.2-0.7,0.2-1c0.1-1.1,0.4-2.1,0.5-3.1l-4.1-1.2l0.6,0.4 C285.1,518.9,286.1,520.7,286.1,522.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M286.1,522.7c0-2-1-3.8-2.7-4.7l-0.6-0.4l-0.5-0.2c-0.2,0-0.4,0-0.5,0c-0.3,1.8-0.9,3.4-1,5.3l5.1,1.5 c0.1-0.4,0.3-0.7,0.4-1.2v-0.1V522.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.6,517.4c-0.3,1.8-0.8,3.4-0.9,5.3C280.8,520.8,281.5,519.2,281.6,517.4 C281.7,517.4,281.7,517.4,281.6,517.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.8,524.1l-5.1-1.5v5.5c0.9,0,1.8-0.2,2.6-0.7C284.6,526.8,285.4,525.5,285.8,524.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M276.3,513.8L276.3,513.8c0.1-0.1,0.1-0.2,0.2-0.4c0-0.2,0.1-0.4,0.2-0.7C276.6,513.2,276.4,513.5,276.3,513.8 z"
}), React.createElement("path", {
  className: "st0",
  d: "M214.3,478.1l34.9,20.1L214.3,478.1C214.4,478,214.3,478.1,214.3,478.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.6,500c-0.1,0.2-0.1,0.5-0.2,0.7c0.8-1.9,1.6-3.7,2.6-5.6l-62.8-36.3c0,0.1-0.1,0.2-0.1,0.3 c-0.7,1.6-1.5,3.1-2.1,4.7L280.6,500z"
}), React.createElement("path", {
  className: "st0",
  d: "M217.3,465.1c0.1-0.2,0.1-0.5,0.2-0.7C217.4,464.6,217.4,464.8,217.3,465.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M214.4,478l-0.3-0.2c0,0,0,0,0,0l0.2,0.1L214.4,478C214.3,478.1,214.4,478,214.4,478z"
}), React.createElement("path", {
  className: "st0",
  d: "M220.1,459.1c-0.7,1.6-1.7,3-2.3,4.6l0.1,0.1C218.6,462.2,219.4,460.7,220.1,459.1z"
}), React.createElement("polygon", {
  className: "st0",
  points: "214.1,477.9 214.2,478 214.1,477.9  "
}), React.createElement("path", {
  className: "st0",
  d: "M210.2,469.6c0.2-0.8,0.4-1.7,0.6-2.5C210.6,467.9,210.5,468.7,210.2,469.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M215.2,456c-0.1,0.2-0.1,0.3-0.2,0.5C215.1,456.3,215.2,456.2,215.2,456L215.2,456z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.9,467C210.9,467,210.9,467,210.9,467c-0.3,0.9-0.5,1.8-0.7,2.6c0,0,0,0.1,0,0.1 C210.5,468.8,210.7,467.9,210.9,467z"
}), React.createElement("path", {
  className: "st0",
  d: "M220.2,458.9c0,0.1-0.1,0.2-0.1,0.3C220.2,459,220.2,459,220.2,458.9L220.2,458.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M276.4,513.9L276.4,513.9C276.3,513.8,276.3,513.8,276.4,513.9L276.4,513.9c0-0.1,0.1-0.3,0.1-0.4 C276.5,513.6,276.4,513.7,276.4,513.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M216.3,468c0.2-0.7,0.4-1.4,0.7-2C216.7,466.7,216.5,467.4,216.3,468z"
}), React.createElement("polygon", {
  className: "st0",
  points: "214.3,478.1 214.3,478.1 256.9,502.6 249.2,498.2  "
}), React.createElement("path", {
  className: "st0",
  d: "M215.3,456L215.3,456c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0,0,0,0C215.1,456.3,215.2,456.2,215.3,456z"
}), React.createElement("polygon", {
  className: "st0",
  points: "214.2,478 214.3,478.1 214.3,478.1  "
}), React.createElement("path", {
  className: "st0",
  d: "M210.9,467c-0.3,0.9-0.5,1.8-0.7,2.7c-0.5,1.9-0.7,4-1,6c0.6,0.1,1.3,0.2,1.8,0.5l3.1,1.8c0,0,0,0,0,0l0,0 c0.4-3.3,1.2-6.5,2.2-9.8c0.2-0.7,0.4-1.3,0.7-2c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.1-0.4,0.2-0.6l0.1,0 c0.6-1.6,1.5-3.1,2.3-4.6c0-0.1,0.1-0.2,0.1-0.3l-5-2.9c-0.1,0.2-0.2,0.3-0.2,0.5C213.3,460,212,463.4,210.9,467z"
}), React.createElement("path", {
  className: "st0",
  d: "M276.4,513.9L276.4,513.9C276.3,513.8,276.3,513.9,276.4,513.9l-19.5-11.2l-42.5-24.6c-0.1,1-0.5,2.1-0.6,3.1 v2.8l61.9,35.7C275.8,517.8,276,515.8,276.4,513.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M214.3,478.1l-0.1-0.1l-0.2-0.1l0,0l-3.1-1.8c-0.5-0.3-1.2-0.4-1.8-0.5c-0.3,1.7-0.8,3.4-0.9,5.2l5.4,3.1v-2.8 C213.8,480.2,214.2,479.1,214.3,478.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M280.4,500.7c0,0.1,0,0.1,0,0.2c0.8-1.9,1.8-3.8,2.7-5.7l-0.1-0.1C282.1,497,281.2,498.8,280.4,500.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M276.5,513.5c0.1-0.6,0.4-1.2,0.5-1.8c-0.1,0.4-0.3,0.7-0.3,1.1C276.6,513,276.5,513.3,276.5,513.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.6,507.8c0.1-0.2,0.2-0.4,0.2-0.6C283.7,507.3,283.6,507.5,283.6,507.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.8,510.7c0.1-0.4,0.2-0.9,0.3-1.3c0.2-0.6,0.3-1.1,0.5-1.7c0.1-0.2,0.2-0.4,0.2-0.6 c0.9-2.8,2.1-5.6,3.4-8.3c0.2-0.3,0.2-0.6,0.4-1l-4.5-2.6c-1,1.9-2,3.8-2.7,5.7c-1.5,3.6-2.5,7.2-3.4,10.8 c-0.1,0.6-0.4,1.2-0.5,1.8c0,0.1-0.1,0.3-0.1,0.4l5,2.9C281.7,514.8,282.2,512.7,282.8,510.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M277.5,518.3c1.1-0.8,2.5-1.1,3.9-0.9c0-0.2,0-0.4,0.1-0.6l-5-2.9c-0.4,2-0.6,3.9-0.8,5.8l0.5,0.3 C276.4,519.3,276.9,518.7,277.5,518.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.2,503.9c-0.4,1.1-1.1,2.1-1.4,3.2c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.3-0.1,0.6-0.2,0.9 C283.9,507.1,284.6,505.5,285.2,503.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M282.8,510.7c-0.6,2-1,4.1-1.4,6.1l0.3,0.2C282,514.9,282.2,512.7,282.8,510.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.6,507.8c-0.2,0.6-0.3,1.1-0.5,1.7c0.1-0.2,0.2-0.5,0.3-0.7C283.5,508.4,283.5,508.1,283.6,507.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M287.3,498.8c-1.3,2.7-2.5,5.5-3.4,8.3c0.4-1.1,1-2.1,1.4-3.2C285.9,502.2,286.4,500.5,287.3,498.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.7,517l-0.3-0.2c0,0.2,0,0.4-0.1,0.6c0.1,0,0.2,0,0.3,0C281.7,517.2,281.7,517.1,281.7,517z"
}), React.createElement("path", {
  className: "st0",
  d: "M277.5,518.3c-0.6,0.4-1,1-1.4,1.7l4.7,2.7c0.1-1.7,0.3-3.5,0.6-5.3C280,517.2,278.6,517.5,277.5,518.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.3,517.4c-0.3,1.8-0.5,3.5-0.6,5.3c0.1-1.8,0.6-3.5,0.9-5.3C281.5,517.4,281.4,517.4,281.3,517.4z"
}));

var SvgMailIcon = function SvgMailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mail_Icon.d1e877a2.svg";
export { ForwardRef as ReactComponent };